export enum Role {
    READ = 'ROLE_BACKOFFICE_ADMIN',
    WRITE = 'ROLE_BACKOFFICE_ADMIN_EDIT',
}

